import React, { useState } from "react";
import { EpisodeData, SeriesData } from "../context/FileLibraryContext";
import { CircularProgress, Paper } from '@mui/material';

export interface VideoPlayerProps {
    series: SeriesData;
    episode: EpisodeData;
}

const VideoPlayerComponent: React.FC<VideoPlayerProps> = (props: VideoPlayerProps) => {
    const [loadedSource, setLoadedSource] = useState<string | null>(null);

    if (!props.episode.streamLinks || props.episode.streamLinks.length === 0) {
        console.log("episode data: ", props.episode);
        return <Paper style={{padding: "1em", textAlign: "center"}}>No stream links available</Paper>;
    }

    const iframeSrc = `${props.episode.streamLinks[0].url}&autoplay=true&loop=true&muted=false&preload=false&responsive=true`;

    return (
        <>
            <div className="video-player">
                <iframe src={iframeSrc}
                    loading="lazy" 
                    allowFullScreen={true}
                    onLoad={() => setLoadedSource(iframeSrc)}
                />
                {loadedSource !== iframeSrc && (
                    <div className="video-player-loading" role="status" aria-live="polite">
                        <CircularProgress size={20} />
                        <span>Loading video...</span>
                    </div>
                )}
            </div>
        </>
    );
}

export default VideoPlayerComponent;